import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { FilterRange } from "common";
import { PromotionsFilters } from "../../../models/promotions-filter.model";
import { PromotionListQueryParams } from "../../../models/promotions-query.model";
import { PromotionListData } from "../../models/promotion-list-data.model";
import { getFormModel } from "./promotion-list-filter-dialog-form-data";
import {
  getProductTypeOptions,
  getPromotionTypeOptions,
  getTransactionTypeOptions,
} from "../../../data/promotion-data";

@Component({
    selector: "ifb-promotion-list-filter-dialog",
    templateUrl: "./promotion-list-filter-dialog.component.html",
    standalone: false
})
export class PromotionListFilterDialogComponent {
  productTypeOptions = getProductTypeOptions;
  transactionTypeOptions = getTransactionTypeOptions;
  promotionTypeOptions = getPromotionTypeOptions;
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<PromotionListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder
  ) {
    this.form = this.formBuilder.group(getFormModel(data.query));
  }

  static show(
    dialog: MatDialog,
    query: PromotionListQueryParams,
    routeData: PromotionListData
  ): Observable<any> {
    return dialog
      .open(PromotionListFilterDialogComponent, {
        data: {
          query,
          routeData,
        },
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  createdOnDateSelected(dataRange: FilterRange<moment.Moment>): void {
    this.form.patchValue({
      createdOnFrom: dataRange.from,
      createdOnTo: dataRange.to,
    });
  }

  startDateSelected(dataRange: FilterRange<moment.Moment>): void {
    this.form.patchValue({
      startDateFrom: dataRange.from,
      startDateTo: dataRange.to,
    });
  }

  endDateSelected(dataRange: FilterRange<moment.Moment>): void {
    this.form.patchValue({
      endDateFrom: dataRange.from,
      endDateTo: dataRange.to,
    });
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new PromotionsFilters(formValues));
  }
}
